<script lang='ts' setup>
import { VContainer } from 'vuetify/lib/components/index.mjs';
// Combine useI18n into one call
const { t, locale } = useI18n()

const sectionData = {
    "section_title": {
        "en": "Why Samurai Rekrutmen?",
        "id": "Mengapa Samurai Rekrutmen?"
    }
}
const rawFeatures = [
    {
        "id": 1,
        "title": {
            "en": "Perfect Match, Not Just More Options",
            "id": "Pencocokan Sempurna, Bukan Sekadar Pilihan"
        },
        "description": {
            "en": "We connect you with opportunities that truly fit your global experience not just more job listings.",
            "id": "Kami menghubungkan Anda dengan peluang yang benar-benar sesuai dengan pengalaman global Anda, bukan hanya sekadar daftar lowongan kerja."
        },
        "image": "/images/landing-page/why-us/01.svg",
    },
    {
        "id": 2,
        "title": {
            "en": "Built for Globally <br> Experienced Talent",
            "id": "Dibangun untuk Talenta Berpengalaman Global"
        },
        "description": {
            "en": "A platform designed for Indonesians with international backgrounds, where your experience truly matters.",
            "id": "Platform yang dirancang untuk warga Indonesia dengan latar belakang internasional, di mana pengalaman Anda sangat dihargai."
        },
        "image": "/images/landing-page/why-us/02.svg",
    },
    {
        "id": 3,
        "title": {
            "en": "Access Opportunities <br> Beyond Borders",
            "id": "Akses Peluang Melampaui Batas"
        },
        "description": {
            "en": "Discover roles with international companies — both remote and on-site all in one place.",
            "id": "Temukan peran di perusahaan internasional — baik jarak jauh (remote) maupun di lokasi — semua dalam satu tempat."
        },
        "image": "/images/landing-page/why-us/03.svg",
    }
]

// FIX: Computed property to handle translation logic
const features = computed(() => {
    return rawFeatures.map(item => ({
        ...item,
        // Pick the string based on current locale ('en' or 'id')
        title: item.title[locale.value as 'en' | 'id'],
        description: item.description[locale.value as 'en' | 'id']
    }))
})
</script>
<template>
    <section class="why-us">
        <VContainer>
            <div class="why-us__inner">
                <div class="why-us__header">
                    <SectionTitle 
                        size="md"
                        align="center"
                        :title="sectionData.section_title[locale as 'en' | 'id']"
                    />
                </div>
                <div class="why-us__content">
                    <div class="why-us__listing">
                        <div class="why-us__item" 
                            v-for="item in features" 
                            :key="item.id" 
                        >
                            <CardWhyUs :data="item"/>
                        </div>
                    </div>
                </div>
            </div>
        </VContainer>
    </section>
</template>
<style lang='scss' scoped>
    .why-us{
        @include vwUnit('padding', 50 0 60, 42 0 42);
        position: relative;
        background-color: #FF1D250D;
        font-family: $primary-font;

        &__header{
            @include vwUnit('margin-bottom', 50, 32);
        }

        &__listing{
            display: grid;
            @include vwUnit('gap', 96, 24);
            grid-template-columns: repeat(3, 1fr);

            @media only screen and (max-width: 767.98px) {
                grid-template-columns: 1fr;
            }   
        }
        &__item{
            margin: 0 auto;

            @media only screen and (max-width: 767.98px) {
                max-width: 300px;
            }
        }
    }

   
</style>
